<template>
  <div id="page2" style="margin-top: 10%">

    <el-row :gutter="20" align="middle">
      <el-col :span="12" ><div class="left"><page2-left></page2-left></div></el-col>
      <el-col :span="12"> <div class="right"><page2-right></page2-right></div></el-col>
    </el-row>
    <br><br><br><br><br>
    <el-row :gutter="20">
      <el-col :span="24"> <div class="bottom"><page2-bottom></page2-bottom></div></el-col>
    </el-row>

  </div>
  <img id="down" src="img/down.png" class="image" style="margin-top: 10%;width: 5%; height: 5%;margin-bottom: 5%">

</template>

<script>
import Page2Left from "@/components/page2/page2Left";
import Page2Right from "@/components/page2/page2Right";
import Page2Bottom from "@/components/page2/page2Bottom";

export default {
  name: "pageTwo",
  components: {Page2Bottom, Page2Right, Page2Left}
}
</script>

<style scoped>
.left{
}
.right{
}
.bottom{
}

#page2{
  animation: fadeIn; /* referring directly to the animation's @keyframe declaration */
  animation-duration: 1s; /* don't forget to set a duration! */
  color: #303133;
}
#down{
  animation: fadeInUp; /* referring directly to the animation's @keyframe declaration */
  animation-duration: 1s; /* don't forget to set a duration! */
  display: inline;
}
</style>